import { SparklesIcon } from '@heroicons/react/16/solid'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Heading } from '../../../../components/ui/Heading'

export default function ClickableCardsMessage() {
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <div className='flex w-full items-center'>
        <div className='flex flex-row items-center text-base font-semibold text-gray-900'>
          <SparklesIcon className='mr-4 size-4 text-aivyBlue' />
          <Heading level={3}>{t('discover.assistant.assistant')}</Heading>
        </div>
      </div>
      <div className='mt-4 rounded-lg border border-lightGrey bg-[#EBEFFD66] p-4'>
        <Heading level={5} className={'text-left'}>
          {t('discover.assistant.onboarding.clickable_cards.title')}
        </Heading>
        <div className='mt-2 text-left text-black'>
          <span className='text-left text-sm font-normal'>
            {t('discover.assistant.onboarding.clickable_cards.description')}
          </span>
        </div>
      </div>
    </React.Fragment>
  )
}
